require('../jhire/services/jv.Reqs');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Sch');
require('../jhire/controllers/candidates/jv.Cand.Details.WorkflowMessager');
require('../jhire/controllers/candidates/jv.Cand.Details.Tasks');
require('../jhire/services/jv.Cand.Details.Evaluations');
require('./jv.shareApplication.controller');
require('./jv.onboarding.controller');
require('./details/jv.candidates.contact.factory');
require('./details/jv.candidates.viewfields.factory');
require('./details/jv.Candidate.Notes.Factory');
require('./details/jv.Candidate.Messages.Factory');
require('./details/jv.Candidate.Tasks.Factory');
require('./details/jv.Candidate.Applications.Controller');
require('./details/jv.Candidate.ManageCollabTeam.Controller');
require('./details/jv.Candidate.Feed.Controller');
require('./details/jv.Candidate.ProfileHistory.Controller');
require('./details/jv.Candidate.Profile.Factory');
require('../jhire/other/jv.CandDetails.findDefaultTemplate');
require('../jhire/services/jv.apply-form-preview.service');
require('../jhire/controllers/candidates/jv.Cand.Details.Paginated');
require('../jhire/controllers/candidates/jv.Cand.Details.Filters');
require('../jhire/controllers/candidates/jv.Cand.Details.Util.Fac');
require('../jhire/controllers/candidates/jv.Cand.Details.Urls.Fac');
require('../jhire/controllers/candidates/jv.Cand.Details.ProcessForm.Fac');
require('../jhire/controllers/candidates/jv.Cand.Details.Summary');
require('../jhire/controllers/candidates/jv.Cand.Details.Intelligent.Messaging');
require('../jhire/controllers/candidates/jv.Cand.Details.CRM');
require('../jhire/controllers/candidates/jv.Cand.Details.Resume');
require('../jhire/services/jv.Cand.Resume.Model');
require('../jhire/controllers/candidates/jv.Cand.Details.Activity');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Scheduler');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Scheduler.Messager');
require('../jhire/controllers/candidates/jv.Cand.Details.Evaluations');
require('../jhire/controllers/candidates/jv.Cand.Details.Evaluations.View');
require('../jhire/controllers/candidates/jv.Cand.Details.Evaluations.Submit');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.PreInterviewForm');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.Reject');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter.Generator');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter.Send');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.OfferLetter.Upload');
require('../jhire/controllers/candidates/jv.Cand.Details.Workflow.EsigOfferLetter');
require('../jhire/controllers/candidates/jv.Cand.Details.Notes');
require('../jhire/controllers/candidates/jv.Cand.Details.Messages');
require('../jhire/controllers/candidates/jv.Cand.QuickForm.Controller');
require('../jhire/controllers/candidates/jv.Cand.Details.Rank.Directive');
require('../jhire/controllers/candidates/jv.Cand.Details.TalentFit.Directive');
require('../common/directives/jv.ActionsDropdown');
require('../common/directives/jv.Dropdown');
require('../common/directives/jv.Select2ModalDropdown');
require('../../stylekit/js/jv.Calendar');
require('../common/directives/jv.auditlog.directive');
require('../common/directives/jv.pagination.directive');
require('../common/jv.responsive');
require('../common/jv.DocuSignAuth.Svc');
require('../common/directives/consentData/jv.Common.DataConsent.directive');
require('../common/directives/jv.Common.Constants.Dates');
require('../common/directives/jv.Common.Directives.DraggableTabs');
require('../common/jv.NumberFormat.mask.directive');
require('../common/directives/jv.Common.Currency.Directive');
require('../common/directives/jv.HideOnBlur');
require('../common/directives/jv.common.currency.applyfield.directive');
require('../common/jv.BrowserDetails');
require('../admin/directives/jv.Admin.CustomFormField.directive');
// require('../../../assets/scripts/videos/recruiter/jv.Videos.App.js');

angular.module('jv.candidate.details.app', [
    //candidate details modules
    // 'jv.services',
    'jv.shareApplication.controller',
    'jv.onboarding.controller',
    'jv.candidates.contact.factory',
    'jv.candidates.viewfields.factory',
    'jv.Candidate.Notes.Factory',
    'jv.Candidate.Messages.Factory',
    'jv.Candidate.Tasks.Factory',
    'jv.Candidate.Applications.Controller',
    'jv.Candidate.ManageCollabTeam.Controller',
    'jv.Candidate.Feed.Controller',
    'jv.Candidate.ProfileHistory.controller',
    'jv.Candidate.Profile.Factory',
    'jv.CandDetails.findDefaultTemplate',
    'jv.apply-form-preview.service',
    'jv.candidate.details.paginated.controller',
    'jv.candidate.details.filters',
    'jv.candidate.details.util.factory',
    'jv.candidate.details.urls.factory',
    'jv.candidate.details.processform.fac',
    'jv.candidate.details.summary.controller',
    'jv.candidate.details.intelligent.messaging.controller',
    'jv.candidate.details.crm.controller',
    'jv.candidate.details.resume.controller',
    'jv.cand.resume.model.factory',
    'jv.candidate.details.activity.controller',
    'jv.candidate.details.workflow.base.controller',
    'jv.candidate.details.workflow.interview.scheduler.controller',
    'jv.candidate.details.workflow.scheduler.messager.controller',
    //jhire modules
    'jv.candidate.details.workflow.scheduler.controller',
    'jv.candidate.details.evaluations.controller',
    'jv.candidate.details.evaluations.view.controller',
    'jv.candidate.details.evaluations.submit.controller',
    'jv.candidate.details.workflow.preInterviewForm.controller',
    'jv.candidate.details.workflow.reject.controller',
    'jv.candidate.details.workflow.offerLetter.controller',
    'jv.candidate.details.workflow.offerLetter.generation.controller',
    'jv.candidate.details.workflow.offerLetter.send.controller',
    'jv.candidate.details.workflow.offerLetter.upload.controller',
    'jv.eSig.OfferLetter.controller',
    'jv.candidate.details.workflow.messager.controller',
    'jv.candidate.details.task.controller',
    'jv.candidate.details.notes.controller',
    'jv.candidate.details.messages.controller',
    'jv.candidate.quickforms.controller',
    'jv.cand.details.rank.directive',
    'jv.cand.details.talent.fit.directive',
    'jv.Common.Directives.Actions',
    'jv.Common.Directives.Dropdown',
    'jv.Common.Directives.jvSelect2ModalDropdown',
    'jv.Common.Directives.Calendar',
    'jv.auditlog.directive',
    'jv.common.pagination.directive',
    'jv.common.responsive',
    'jv.App.DocuSignAuth.Svc',
    'jv.Common.DataConsent',
    'jv.Common.Constants.Dates',
    'jv.Common.Directives.Draggable.Tabs',
    'jv.common.numberFormatter.directive',
    'jv.common.currency.directive',
    'jv.Common.Directives.HideOnBlur',
    'jv.common.currency.applyfield.directive',
    'jv.Common.browser.details',
    'jv.Admin.CustomFormField.directive',
    //Common modules
    'jv.Videos.App'
]);